import { Component, Input, OnInit } from '@angular/core';
import { ModalController} from '@ionic/angular';
import { AlertService } from 'src/app/services/alert.service';

@Component({
  selector: 'app-sc-survey',
  templateUrl: './sc-survey.component.html',
  styleUrls: ['./sc-survey.component.scss'],
})
export class ScSurveyComponent implements OnInit {

  @Input() survey :any = null
  constructor(
    private modalController: ModalController,private alertService:AlertService
  ) {

  }
  ngOnInit() { }

  async accept() {
    await this.alertService.presentLoading('cargando')
    await this.modalController.dismiss('accept');
  }


}
